import { render } from "./Poster.vue?vue&type=template&id=e52c2fd0&scoped=true"
import script from "./Poster.vue?vue&type=script&lang=js"
export * from "./Poster.vue?vue&type=script&lang=js"

import "./Poster.vue?vue&type=style&index=0&id=e52c2fd0&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e52c2fd0"]])

export default __exports__